/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface PlaceIdProvidedErrorResponseContent
 */
export interface PlaceIdProvidedErrorResponseContent {
    /**
     * An error message
     * @type {string}
     * @memberof PlaceIdProvidedErrorResponseContent
     */
    message: string;
    /**
     * A unique identifier for the Roblox experience/universe.
     * @type {string}
     * @memberof PlaceIdProvidedErrorResponseContent
     */
    suggestedUniverseId: string;
}


/**
 * Check if a given object implements the PlaceIdProvidedErrorResponseContent interface.
 */
export function instanceOfPlaceIdProvidedErrorResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "suggestedUniverseId" in value;
    return isInstance;
}

export function PlaceIdProvidedErrorResponseContentFromJSON(json: any): PlaceIdProvidedErrorResponseContent {
    return PlaceIdProvidedErrorResponseContentFromJSONTyped(json, false);
}

export function PlaceIdProvidedErrorResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaceIdProvidedErrorResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': json['message'],
        'suggestedUniverseId': json['suggestedUniverseId'],
    };
}

export function PlaceIdProvidedErrorResponseContentToJSON(value?: PlaceIdProvidedErrorResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
        'suggestedUniverseId': value.suggestedUniverseId,
    };
}

